var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"nofillstroke"},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.6957 0H0V16.6957H7.30435V24H24V7.30435H16.6957V0ZM16.6957 7.30435H7.30435V16.6957H16.6957V7.30435Z","fill":"#3C4043","fill-opacity":"0.99"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }